import { IconButton, makeStyles } from "@material-ui/core";
import Clear from "@material-ui/icons/Clear";
import { useSnackbar } from "notistack";
import React from "react";

const useStyles = makeStyles({
  icon: {
    color: "white"
  }
});

const DismissNotificationButton = key => {
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();
  const onClick = () => {
    closeSnackbar(key);
  };
  return (
    <IconButton size="small" onClick={onClick} className={classes.icon}>
      <Clear />
    </IconButton>
  );
};

export default DismissNotificationButton;
